<template>
  <div class="page">
    <el-dialog
      :append-to-body="true"
      :title="title"
      :visible.sync="addDialogVisible"
       :close-on-click-modal="false"
      width="40%"
      :before-close="closeViewDialog">
      <div class="description"  v-if="editType !== 'auth'">
        <!-- <el-row :span="24">
          <el-col :span="4"><span class="star">*</span>角色名称：</el-col>
          <el-col :span="8">
             <el-input v-model="roleDetail.roleName" placeholder="请输入角色名称" clearable class=""></el-input>
          </el-col>
          <el-col :span="4">角色描述：</el-col>
          <el-col :span="8">
             <el-input
              type="textarea"
              v-model="roleDetail.remark"
              placeholder="请输入角色描述" clearable class=""></el-input>
          </el-col>
        </el-row> -->

        <el-form label-width="90px" ref="ruleForm"  :rules="rules" :model="roleDetail">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model.trim="roleDetail.roleName" autocomplete="off" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="remark">
            <el-input v-model.trim="roleDetail.remark" autocomplete="off" placeholder="请输入角色描述"></el-input>
          </el-form-item>
      </el-form>

      </div>
      <div v-if="editType === 'auth'" class="menu">
        <div class="title"  v-if="editType !== 'auth'">菜单权限管理</div>
        <el-tree
        :render-after-expand="false"
        ref="tree"
        :data="permissionList"
        show-checkbox
        node-key="menuId"
        :check-strictly = "true"
        @check-change="checkChange"
        @node-click="handleNodeClick"
        :default-checked-keys="defaultCheckedKeys"
        :props="defaultProps">
        <div class="centerRow" slot-scope="{ node,data }">
          <div class="treeNodeText">
             {{node.label}}
          </div>
          <div  class="childCheck">
            <childCheck
            v-if="data.buttonList && data.buttonList.length > 0"
            :buttonList="data.buttonList"
            :node="node"
            :defaultBtnKeys="defaultBtnKeys">
            </childCheck>
            <!-- <el-checkbox v-for="(item,index) in data.buttonList" :key="index" v-model="item.buttonValue" :label="item.buttonName" ></el-checkbox> -->
          </div>
        </div>
      </el-tree>
      </div>
      <!-- <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="createTime"
          label="模块">
        </el-table-column>
        <el-table-column
          label="权限">
        </el-table-column>
      </el-table> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="updateOrAddRole()" size="small" type="primary">{{btnText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { roleUpdae, roleAdd, listOwnerMenu, rightAccessList, bindAccess, getMenuListByRoleId } from '@/api/auth'
import childCheck from '@/components/common/childCheck'
import { mapGetters } from 'vuex'
export default {
  components: {
    childCheck
  },
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object || null
    },
    editType: {
      type: String
    }
  },
  data () {
    return {
      tableData: [],
      roleDetail: {
        roleName: this.editData ? this.editData.roleName : '',
        remark: this.editData ? this.editData.remark : ''
      },
      permissionList: [
      ],
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      },
      defaultCheckedKeys: [],
      allArr: [],
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { max: 20, message: '长度需小于 20 个字符', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入角色描述', trigger: 'blur' },
          { max: 40, message: '长度需小于 40 个字符', trigger: 'blur' }
        ]
      },
      checkList: [],
      defaultBtnKeys: null
    }
  },
  created () {
    console.log('this.editData:', this.editData)
    // menuList().then(res => {
    //   res = res.data
    //   console.log('获取菜单数据：', res)
    // })
    // this.getRightAccessList()
    if (this.editType === 'auth') {
      if (this.getCacheListOwnerMenu) {
        this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
      } else {
        this.getListOwnerMenu()
      }
      this.getRoleDetail(this.editData.roleId)
    }
  },
  computed: {
    ...mapGetters(['getCacheListOwnerMenu']),
    btnText () {
      if (this.editType === 'edit') {
        return '修改'
      } else if (this.editType === 'add') {
        return '添加'
      } else {
        return '确认分配'
      }
    },
    title () {
      if (this.editType === 'edit') {
        return '编辑角色'
      } else if (this.editType === 'add') {
        return '添加角色'
      } else {
        return '分配权限角色'
      }
    }
  },
  methods: {
    closeViewDialog () {
      this.$emit('closeAddViewDialog')
    },
    closeAddViewDialog () {
      this.$emit('closeAddViewDialog')
    },
    updateRole () {
      console.log('editData:', this.editData)
      const params = {
        roleId: this.editData.roleId,
        roleName: this.roleDetail.roleName,
        remark: this.roleDetail.remark
      }
      console.log('params:', params)
      roleUpdae(params).then(res => {
        res = res.data
        console.log('更新角色返回数据：', res)
        if (res.code === 0 || res.code === 200) {
          this.$message.success('更新成功')
          this.closeViewDialog()
          this.$emit('update-role-list')
          // const menuArr = this.getCheckedKeys()
          // console.log('menuArr:', menuArr)
          // // 对用户进行菜单绑定
          // this.roleBindAccess(this.editData.roleId, menuArr, this.editType)
        }
      })
    },
    async updateOrAddRole () {
      console.log('type:', this.editType)
      if (this.editType === 'edit') {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.updateRole()
          }
        })
      } else if (this.editType === 'auth') {
        // 直接调用分配权限的
        const menuArr = await this.$refs.tree.getCheckedKeys()
        console.log('menuArr:', menuArr)
        const btnCheck = this.getBtnCheckedKeys()
        const btnArr = btnCheck.arr
        console.log('按钮数组：', btnArr)
        // 对用户进行菜单绑定
        this.roleBindAccess(this.editData.roleId, menuArr, btnArr, this.editType)
      } else {
        // const checkArr = this.getBtnCheckedKeys()
        // console.log('按钮数组：', checkArr)
        // console.log('this.permissionList', this.permissionList)
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            const params = {
              roleName: this.roleDetail.roleName,
              remark: this.roleDetail.remark
            }
            console.log('params:', params)
            roleAdd(params).then(async res => {
              res = res.data
              console.log('添加角色返回数据：', res)
              if (res.code === 0) {
                this.$message.success('添加角色成功')
                this.closeViewDialog()
                this.$emit('update-role-list')
              }
            })
          }
        })
      }
    },
    // 获取用户对应的菜单列表
    getListOwnerMenu () {
      listOwnerMenu().then(res => {
        res = res.data
        console.log('获取用户对应的菜单data：', res.data)
        if (res.data) {
          this.permissionList = res.data
        }
      })
    },
    roleBindAccess (roleid, menuArr, btnArr, type) {
      const params = {
        roleId: roleid,
        menuIds: menuArr.join(','),
        buttonIds: btnArr.join(',')
      }
      bindAccess(params).then(res => {
        res = res.data
        console.log('绑定返回数据：', res)
        const message =
          type === 'edit'
            ? '更新成功'
            : type === 'auth'
              ? '权限分配成功'
              : '添加成功'
        this.$message.success(message)
        this.closeViewDialog()
        this.$emit('update-role-list')
      })
    },
    getRightAccessList () {
      // 获取用户授权列表
      rightAccessList().then(res => {
        res = res.data
        // console.log('授权列表：', res)
      })
    },
    handleNodeClick (data) {
      // console.log('点击了树：', data)
    },
    checkChange (data) {
      // console.log('点击的data:', data)
      const node = this.$refs.tree.getNode(data.menuId)
      this.updateBtnList(node, data)// 更新buttonList引起子组件更新
      this.setNode(node)
      // console.log('选中的树变化：', data)
      // const selectRoleAll = this.$refs.tree.getCheckedNodes()
      // const parentAll = this.$refs.tree.getHalfCheckedNodes()
      // console.log('选中的数组：', selectRoleAll)
      // console.log('半选中：', parentAll)
      // const menuIdArr = []
      // selectRoleAll.concat(parentAll).forEach((ele) => {
      //   menuIdArr.push(ele.menuId)
      // })
      // this.allArr = menuIdArr
      // console.log('allArr', this.allArr)
    },
    // 递归设置子节点和父节点
    setNode (node) {
      if (node.checked) {
      // 如果当前是选中checkbox,则递归设置父节点和父父节点++选中
        this.setParentNode(node)
      } else {
      // 如果当前是取消选中checkbox,则递归设置子节点全部取消选中
        this.setChildNode(node)
      }
    },
    updateBtnList (node, data) {
      // 如果取消勾选，要把同级别目录下的按钮列表所有的check置为false
      if (!node.checked) {
        if (data.buttonList && data.buttonList.length > 0) {
          data.buttonList.forEach(item => {
            item.check = false
          })
          // data.buttonList = Object.assign([], data.buttonList)
        }
      }
    },
    // 递归设置父节点全部选中
    setParentNode (node) {
      if (node.parent) {
        for (const key in node) {
          if (key === 'parent') {
            node[key].checked = true
            this.setParentNode(node[key])
          }
        }
      }
    },
    // 递归设置子节点全部取消选中
    setChildNode (node) {
      if (node.childNodes && node.childNodes.length) {
        node.childNodes.forEach(item => {
          item.checked = false
          this.setChildNode(item)
        })
      }
    },
    getBtnCheckedKeys (menuList) {
      // 循环获取所有被选中的按钮，返回数组值
      const btnCheckArr = []
      const btnCheck = {}
      function getKeys (list) {
        list.forEach(item => {
          // 按钮循环
          if (item.buttonList && item.buttonList.length > 0) {
            item.buttonList.forEach(btnItem => {
              if (menuList) {
                // 直接将所有的按钮过滤回去
                if (btnItem.buttonId) {
                  btnCheckArr.push(btnItem.buttonId)
                  btnCheck[btnItem.buttonId] = btnItem.check
                }
              } else {
                // 过滤返回选中的按钮
                if (btnItem.check && btnItem.buttonId) {
                  btnCheckArr.push(btnItem.buttonId)
                  btnCheck[btnItem.buttonId] = btnItem.check
                }
              }
            })
          }
          // 菜单循环
          if (item.childMenus && item.childMenus.length > 0) {
            getKeys(item.childMenus)
          }
        })
      }
      if (menuList) {
        getKeys(menuList)
      } else {
        getKeys(this.permissionList)
      }
      console.log('this.permissionList:', this.permissionList)
      console.log('返回的两个数值：', { arr: btnCheckArr, check: btnCheck })
      return { arr: btnCheckArr, check: btnCheck }
      // this.permissionList.forEach()
    },
    getRoleDetail (roleId) {
      // 获取指定角色信息
      getMenuListByRoleId(roleId).then(res => {
        res = res.data
        console.log('指定角色信息：', res)
        if (res.data) {
          // this.permissionList = res.data.menuVOS
          // const menuId = []
          this.defaultCheckedKeys = this.getMenuId(res.data)
          const btnCheck = this.getBtnCheckedKeys(res.data)
          console.log('指定角色信息btnCheck：', btnCheck)
          this.defaultBtnKeys = btnCheck.check
        } else {
          this.defaultBtnKeys = {}
        }
      })
    },
    getMenuId (menu) {
      const menuArr = []
      function getId (menuParams) {
        menuParams.forEach(item => {
          menuArr.push(item.menuId)
          if (item.childMenus && item.childMenus.length > 0) {
            getId(item.childMenus)
          }
        })
      }
      getId(menu)
      console.log('过滤后返回的菜单：', menuArr)
      return menuArr
    }
  }
}
</script>
<style lang='less' scoped>
.page{
  .description{
    line-height: 30px;
    .el-col:nth-child(odd){
      text-align: right;
    }
  }
  .title{
    font-weight: bold;
    margin: 10px 0;
    font-weight: bold;
    font-size: 16px;
  }
  .star{
    color: red;
  }
  .menu{
    .centerRow{
      display: flex;
      align-items: middle;
    }
    .childCheck{
      margin-left: 50px;
      padding: 10px 0;
      display: flex;
      white-space: break-spaces;
    }
    .treeNodeText{
        display: flex;
        // align-items: center;
        white-space: nowrap;
    }
  }
}
/deep/ .el-tree-node__content{
  height: auto;
  min-height: 26px;
  max-height: 200px;
  align-items: flex-start;
}

/deep/ .el-tree-node {
white-space: normal;
}
</style>
